export default {
  app: 'APP_EXFOCY',
  api: '/portal'
};
